import { useContext } from 'react';
import { AngularContext } from 'react-app';
import useRolePlayPermissions from '../hooks/use-role-play-permissions';
import SubmissionsGalleryContent from './submissions-gallery-content';

const SubmissionsGallery = () => {
  const { injectServices } = useContext(AngularContext);
  const [$state] = injectServices(['$state']);
  const rolePlayId = Number($state?.params?.rolePlayId);
  const { isAdminOrMentor } = useRolePlayPermissions();

  if (!isAdminOrMentor) return null;

  return <SubmissionsGalleryContent rolePlayId={rolePlayId} />;
};

export default SubmissionsGallery;
